import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Container } from 'components'
import { SSOError } from './components'

import helpers from 'helpers'

import useStyles from './styles'

const LoginSSOError = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const { slug } = useParams()
  const [checked, setChecked] = useState(false)

  // O backend força o slug default (/dponet/sso/error); se houver um slug
  // white-label salvo, redireciona para manter o slug correto na URL.
  useEffect(() => {
    const redirectPath = helpers.whiteLabel.storedSlugRedirectPath(
      slug,
      location.pathname,
      location.search,
    )
    if (redirectPath) {
      history.replace(redirectPath)
      return
    }
    setChecked(true)
  }, [slug, location.pathname, location.search, history])

  if (!checked) return null

  return (
    <Container maxWidth="sm" className={classes.root}>
      <SSOError slug={slug} />
    </Container>
  )
}

export default LoginSSOError
